export default __webpack_public_path__ + "static/O0033-db98e88581f3122d55e03bcbd8fa5aab.png";